import React, { useState } from 'react'

import { ServicesReportList } from './ServicesReportList'
import './TimelineReport.scss'

export const TimelineReport = (props) => {
  const [startDate, setStartDates] = useState('')
  const [endDate, setEndDates] = useState('')
  const { bookingsFromDatabase } = props

  return (
    <wb-accordion theme="light" prevent-mobile-flyout>
      <wb-accordion-item>
        <wb-accordion-toggle>Timeline Tracker</wb-accordion-toggle>
        <wb-accordion-section>
          <wb-accordion-mobile-header className="wb-type-heading-xs">
            Close
          </wb-accordion-mobile-header>
          <wb-accordion-content>
            <p>
              Please provide start and end Date for create your service timeline
              report
            </p>
            <wb-datepicker-control class="timeline-tracker">
              <wb-input-control>
                <wb-input>
                  <label>Start Date: </label>
                  <input
                    type="date"
                    min="2020-01-01"
                    value={startDate}
                    onChange={(e) => setStartDates(e.target.value)}
                  />
                </wb-input>
              </wb-input-control>
              <wb-input-control>
                <wb-input>
                  <label>End Date: </label>
                  <input
                    type="date"
                    min="2020-01-01"
                    value={endDate}
                    onChange={(e) => setEndDates(e.target.value)}
                  />
                </wb-input>
              </wb-input-control>
            </wb-datepicker-control>
            <ServicesReportList
              startDate={startDate}
              endDate={endDate}
              bookingsFromDatabase={bookingsFromDatabase}
            />
          </wb-accordion-content>
        </wb-accordion-section>
      </wb-accordion-item>
    </wb-accordion>
  )
}
